export const SUPPORT_FORMATTED_NUMBER = "+19169997497";

export const NGROK_ADDRESS = "https://wealthy-piranha-hideously.ngrok-free.app";

/**
 * These constants are used to track the versions of the AI prompt used to generate the summary.
 * Ideally while we use the existing database structure to maintain this data we should version the prompt accordingly.
 * Adding a new version should be as simple as adding a new item to the AI_SUMMARY_VERSION, updating the CURRENT_AI_SUMMARY_VERSION
 * and picking an emoji unicode to represent it. (I know, insane.)
 */
export const AI_SUMMARY_VERSIONS = ["v1", "v2", "v3"] as const;

export const VersionReaction: Record<(typeof AI_SUMMARY_VERSIONS)[number], string> = {
  v1: "1fae0",
  v2: "1f929",
  v3: "1f327", // 🌧️ rain emoji for v3
} as const;
export const CURRENT_AI_SUMMARY_VERSION = "v3" as const;
export const LIKE_REACTION = "1f44d" as const;
export const DISLIKE_REACTION = "1f44e" as const;
export const GENERATOR_REACTION = "1f930" as const;
